<template>
  <form
      class="mb-20"
      data-cy="register-form"
      v-on:submit.prevent="register"
  >
    <div class="mb-3">
      <label class="font-bold block mb-1 for-reader" for="name-input"
      >Name</label
      >
      <input
          class="input-text-1 mb-3"
          data-cy="name-input"
          id="name-input"
          placeholder="name"
          type="text"
          v-model="user.name"
      />
    </div>
    <div class="mb-3">
      <label class="font-bold block mb-1 for-reader" for="username-input"
      >Username</label
      >
      <input
          class="input-text-1 mb-3"
          data-cy="username-input"
          id="username-input"
          placeholder="username"
          type="text"
          v-model="user.username"
      />
    </div>
    <div class="mb-3">
      <label class="font-bold block mb-1 for-reader" for="email-input"
      >Email</label
      >
      <input
          class="input-text-1 mb-3"
          data-cy="email-input"
          id="email-input"
          placeholder="email"
          type="text"
          v-model="user.email"
      />
    </div>
    <div class="mb-3">
      <label class="font-bold block mb-1 for-reader" for="password-input"
      >Password</label
      >
      <input
          class="input-text-1 mb-3"
          data-cy="password-input"
          id="password-input"
          placeholder="password"
          type="password"
          v-model="user.password"
      />
    </div>

    <input
        class="button-1"
        data-cy="register-button"
        type="submit"
        value="Register"
    />
  </form>
</template>

<script>
import { API_URL } from "../env.js";

export default {
  data() {
    return {
      user: {}
    };
  },

  components: {},

  methods: {
    async register() {
      this.$loading(true);
      const res = await this.$store.dispatch("REGISTER_USER", this.user);
      this.$loading(false);
      if (res.success) {
        this.$router.push({ path: "/" });
      } else {
        alert(res.message);
      }
    }
  }
};
</script>
